import { createAction, props } from '@ngrx/store';

export const setMasterList = createAction('[Master] Set List Based on Key', props<{ data: any }>());
export const setMasterAPIProgressStatus = createAction('[Master] Set Progress Status', props<{ data: any }>());
export const setMasterAPICompleteStatus = createAction('[Master] Set Complete Status', props<{ data: any }>());
export const addDataToMaster = createAction('[Master] Add Data', props<{ data: any }>());
export const updateDataToMaster = createAction('[Master] Update Data', props<{ data: any }>());
export const removeDataFromMaster = createAction('[Master] Remove Data', props<{ data: any }>());